/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_1_DescInputs */

const en_vc_ft_1_desc = /** @type {(inputs: Vc_Ft_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real Bézier anchors and handles, Smart Guides and a contextual task bar that offers the next likely action.`)
};

const zh_vc_ft_1_desc = /** @type {(inputs: Vc_Ft_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真正的贝塞尔锚点和手柄、智能参考线，以及会提示下一步操作的上下文任务栏。`)
};

/**
* | output |
* | --- |
* | "Real Bézier anchors and handles, Smart Guides and a contextual task bar that offers the next likely action." |
*
* @param {Vc_Ft_1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_1_desc = /** @type {((inputs?: Vc_Ft_1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_1_desc(inputs)
	return zh_vc_ft_1_desc(inputs)
});
export { vc_ft_1_desc as "vc.ft.1.desc" }